import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
// The legacy, untyped multipart upload helper in src/api.js — reused
// deliberately, same convention PrescriptionPanel.tsx follows for
// uploadPatientDocument (see that file's own comment and src/api.js's
// header comment on uploadVendorInvoice).
import { uploadVendorInvoice } from '@/api';
import type { VendorInvoiceUpload } from './types';

/** Desk file-picker upload — the phone-via-QR path polls session status
 * directly instead (see ProcurementInvoiceQRModal.tsx), no mutation needed. */
export function useUploadVendorInvoice() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ file, poId }: { file: File; poId?: number }): Promise<VendorInvoiceUpload> => uploadVendorInvoice(file, poId),
    onSuccess: (upload) => {
      queryClient.setQueryData(keys.pharmacy.vendorInvoiceUpload(upload.id), upload);
    },
  });
}
